import React from "react";
import DatePicker from "react-datepicker";

const PersonalTab = ({ state, handleChange, handleGenderChange, handleResidentialAddressChange }) => {
  return (
    <div className="row">
      <div className="col-md-6 col-sm-12">
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <select id="Title" name="Title" className="form-control" style={{ maxWidth: "80px" }} value={state.Title} onChange={handleChange}>
            <option value="Mr">Mr.</option>
            <option value="Ms">Ms.</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="FirstName">First name</label>
          <input id="FirstName" name="FirstName" type="text" className="form-control required-control" value={state.FirstName} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label htmlFor="LastName">Last name</label>
          <input id="LastName" name="LastName" type="text" className="form-control required-control" value={state.LastName} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label htmlFor="NationalIDNumber">National Identification Number</label>
          <input id="NationalIDNumber" name="NationalIDNumber" type="text" className="form-control" value={state.NationalIDNumber} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label htmlFor="BirthDate">Date of birth</label>
          <div className="tw-w-full">
            <DatePicker
              selected={state.BirthDate}
              onChange={(date) => handleChange({ target: { name: "BirthDate", value: date } })}
              dateFormat="dd-MM-yyyy"
              className="form-control datepickerx tw-w-full"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              isClearable={true}
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="Gender">Gender</label>
          <div className="tw-flex tw-gap-4" style={{ marginBottom: 10 }}>
            <label className="radio-inline">
              <input type="radio" id="rbtnMale" name="rbtnGender" checked={state.Gender === 2} onChange={handleGenderChange} />
              Male
            </label>
            <label className="radio-inline">
              <input type="radio" id="rbtnFemale" name="rbtnGender" checked={state.Gender === 1} onChange={handleGenderChange} />
              Female
            </label>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="ResidentialAddress">Residential address</label>
          <textarea
            rows={2}
            className="form-control tw-w-full"
            id="residential_address"
            name="residential_address"
            value={state.Contact.residential_address}
            onChange={handleResidentialAddressChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalTab;
